// extracted by mini-css-extract-plugin
module.exports = {"media":"Media_media__8A5mk"};